import { render, staticRenderFns } from "./InvoicingPage.vue?vue&type=template&id=2cfc4ce0&"
import script from "./InvoicingPage.vue?vue&type=script&lang=js&"
export * from "./InvoicingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports